
export function setPreferredLipidsUnit(state, preferredLipidsUnit) {
  state.preferredLipidsUnit = preferredLipidsUnit;
}

export function setPreferredGlucoseUnit(state, preferredGlucoseUnit) {
  state.preferredGlucoseUnit = preferredGlucoseUnit;
}
